import { Button, Tooltip } from '@mui/material';
import React, {useState} from 'react'
import { Link } from 'react-router-dom';
import ModalPNG from '../Components/Alertas/ModalPNG';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';

function downloadURI(uri, name) {
    var link = document.createElement('a');
    link.download = name;
    link.href = uri;

    /* link.setAttribute('crossOrigin', 'anonymous'); */

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

//Funcion para calcular la distancia entre dos puntos
function distancia(p1,p2) {
    const x = p1.x - p2.x
    const y = p1.y - p2.y
  
    return Math.sqrt(x * x + y * y)
}
  

const ExportarPNG = (props) => {

    const {
        stageRef, 
        setStageX, 
        setStageY, 
        setStageScale, 
        stageScale, 
        stageX, 
        stageY,
        nodos,
        setStageWidth,
        setStageHeight
    } = props;

    const [nombreArchivo, setNombreArchivo] = useState('Archivo')
    const [abrirModal, setAbrirModal] = useState(false);
    const handleClose = () => setAbrirModal(false);
    const [guardardoStageX, setguardardoStageX] = useState(stageX)
    const [guardardoStageY, setguardardoStageY] = useState(stageY)
    const [guardarScale, setGuardarScale] = useState(stageScale)

    const exportData = () => {

        let minimoX = nodos[0].x;
        let minimoY = nodos[0].y;

        let maximoX = nodos[0].x;
        let maximoY = nodos[0].y;

        let bigW = nodos[0].width
        let bigH = nodos[0].height

        let maximoImgW = 0;
        let maximoImgH = 0;

        nodos.forEach((nodo) => {
            if(nodo.tieneImagen){
                if(nodo.imgWidth > maximoImgW){
                    maximoImgW = nodo.imgWidth
                }
                if(nodo.imgHeight > maximoImgH){
                    maximoImgH = nodo.imgHeight
                }
            }
            
            if(nodo.width > bigW){
                bigW = nodo.width
            }
            if(nodo.height > bigH){
                bigH = nodo.height
            }
            if(nodo.x-nodo.imgWidth < minimoX){
                minimoX = nodo.x-nodo.imgWidth
            }
            if(nodo.x+nodo.imgWidth > maximoX){
                maximoX = nodo.x+nodo.imgWidth
            }
            if(nodo.y-nodo.imgHeight < minimoY){
                minimoY = nodo.y-nodo.imgHeight
            }
            if(nodo.y > maximoY){
                maximoY = nodo.y
            }
        });
        
        
        //Punto arriba izq
        let p1 = {
            x: minimoX,
            y: minimoY
        }
        //Punto arriba derecha
        let p2 = {
            x: maximoX,
            y: minimoY
        }
        //Punto abajo derecha
        let p3 = {
            x: minimoX,
            y: maximoY
        }
        //Punto abajo izquierda
        let p4 = {
            x: maximoX,
            y: maximoY
        }
        const largo = Math.round(distancia(p1, p2));
        
        // console.log(minimoX, minimoY)
        // console.log(maximoX, minimoY)
        // console.log(maximoY, minimoX)
        // console.log(maximoX, maximoY)
        // console.log(Math.round(distancia(p1, p2)))
        // console.log(Math.round(distancia(p1, p4)))

        setAbrirModal(false);
        

        // El X e Y del metodo toDataURL() me dan el punto de inicio para exportar el archivo
        // el width y el height me dan el tamaño máximo que podria tener
        // de esta forma logramos exportar el achivo completo o un sector del stage,
        // independiente del zoom que se haga.

        const uri = stageRef.current.toDataURL({
            x: minimoX+stageRef.current.attrs.x,
            y: minimoY+stageRef.current.attrs.y,
            width: Math.round(distancia(p1, p2)+bigW),
            height: Math.round(distancia(p1, p3)+bigH),
            pixelRatio: 2
        });
        
        // we also can save uri as file
        // but in the demo on Konva website it will not work
        // because of iframe restrictions
        // but feel free to use it in your apps:
        downloadURI(uri, nombreArchivo+'.png');
        setNombreArchivo('Archivo');
    };
    
    return (
        <>  
            {abrirModal &&(
                <ModalPNG
                    abrirModal={abrirModal}
                    setAbrirModal={setAbrirModal}
                    handleClose={handleClose}
                    exportData={exportData}
                    setNombreArchivo={setNombreArchivo}
                />
            )}
            <Tooltip title='Exportar como PNG'>
                <Button onClick={()=>{
                        setAbrirModal(true) 
                        setStageScale(1)
                        setStageX(0)
                        setStageY(0)
                    }} variant="outlined">
                    <SystemUpdateAltIcon/>
                </Button>
            </Tooltip>
        </>
    )
}

export default ExportarPNG;